export default "__VITE_ASSET__CT7exMJu__ 640w, __VITE_ASSET__BCGktJeD__ 1024w, __VITE_ASSET__8XDf$ir1__ 1920w";